module.exports = __webpack_public_path__ + "static/media/RallyVideo2020.cb55e462.mp4";